import { useState, useEffect } from "react";

const useHeaderHeight = () => {
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const header = document.getElementById("header");
    if (header && !headerHeight) {
      setHeaderHeight(header.offsetHeight);
    }
  }, []);

  return headerHeight;
};

export default useHeaderHeight;
